<p class="title is-size-5" translate>kws.basicInfo.basicInfo</p>
<p class="title is-size-6" translate>kws.basicInfo.private</p>
<div class="is-flex is-justify-content-space-between">
  <div class="is-flex is-flex-direction-column">
    <span translate>kws.basicInfo.testing</span>
    @if (links().anonymizedTesting) {
      <span translate>kws.basicInfo.anonymizedTesting</span>
    }
    <span translate>kws.basicInfo.production</span>
  </div>
  <div class="is-flex is-flex-direction-column">
    <a
      class="has-text-primary has-text-weight-bold has-text-right"
      [href]="testingHref()"
      target="_blank"
    >
      {{ links().testing }}
    </a>
    @if (links().anonymizedTesting) {
      <a
        class="has-text-primary has-text-weight-bold has-text-right"
        [href]="links().anonymizedTesting"
        target="_blank"
      >
        {{ links().anonymizedTesting }}
      </a>
    }
    <a
      class="has-text-primary has-text-weight-bold has-text-right"
      [href]="productionHref()"
      target="_blank"
    >
      {{ links().production }}
    </a>
    @if (dnsMissing()) {
      <span
        class="has-text-warning-dark has-text-right is-size-7"
        [translate]="
          isAtruvia() ? 'kws.basicInfo.dnsMissingAtruvia' : 'kws.basicInfo.dnsMissing'
        "
        [translateParams]="{ host: dns().host }"
      ></span>
    }
  </div>
</div>
<hr />

<p class="title is-size-6" translate>kws.basicInfo.business</p>

<div class="is-flex is-justify-content-space-between">
  <div class="is-flex is-flex-direction-column">
    <span translate>kws.basicInfo.testing</span>
    @if (links().anonymizedTesting) {
      <span translate>kws.basicInfo.anonymizedTesting</span>
    }
    <span translate>kws.basicInfo.production</span>
  </div>
  <div class="is-flex is-flex-direction-column">
    <a
      class="has-text-primary has-text-weight-bold has-text-right"
      [href]="testingBusinessHref()"
      target="_blank"
    >
      {{ testingBusinessHref() }}
    </a>
    @if (links().anonymizedTesting) {
      <a
        class="has-text-primary has-text-weight-bold has-text-right"
        [href]="anonymizedTestingBusinessHref()"
        target="_blank"
      >
        {{ anonymizedTestingBusinessHref() }}
      </a>
    }
    <a
      class="has-text-primary has-text-weight-bold has-text-right"
      [href]="productionBusinessHref()"
      target="_blank"
    >
      {{ productionBusinessHref() }}
    </a>
  </div>
</div>

@if (hasNachlass()) {
  <hr />

  <p class="title is-size-6" translate>kws.basicInfo.estate</p>

  <div class="is-flex is-justify-content-space-between">
    <div class="is-flex is-flex-direction-column">
      <span translate>kws.basicInfo.testing</span>
      @if (links().anonymizedTesting) {
        <span translate>kws.basicInfo.anonymizedTesting</span>
      }
      <span translate>kws.basicInfo.production</span>
    </div>
    <div class="is-flex is-flex-direction-column">
      <a
        class="has-text-primary has-text-weight-bold has-text-right"
        [href]="testingEstateHref()"
        target="_blank"
      >
        {{ testingEstateHref() }}
      </a>
      @if (links().anonymizedTesting) {
        <a
          class="has-text-primary has-text-weight-bold has-text-right"
          [href]="anonymizedTestingEstateHref()"
          target="_blank"
        >
          {{ anonymizedTestingEstateHref() }}
        </a>
      }
      <a
        class="has-text-primary has-text-weight-bold has-text-right"
        [href]="productionEstateHref()"
        target="_blank"
      >
        {{ productionEstateHref() }}
      </a>
    </div>
  </div>
}
